/**
 * `/v1/dashboard` in local mode (plan §6.6).
 *
 * Returns the FULL filtered row set, never a page. The dashboard's own tables
 * truncate for display, but risk score is normalised over the filtered set, so
 * truncating here would score the visible rows against themselves and produce a
 * different — and wrong — table than the live route (plan §6.6 sort-key
 * contract: no SQL limit may run before query-relative normalization).
 */
import type { DashboardPayload, DashboardQuery } from '@meridian/contracts';

import { computeBreadth } from '../../analytics/breadth';
import { aggregateSectors, toSectorAggregate } from '../../analytics/sector-aggregate';
import { filterUniverse } from '../../selectors/filter-universe';
import { toWireSecurity, type DerivedSecurity } from '../../universe/derive-security';

export function buildDashboard(
  rows: readonly DerivedSecurity[],
  query: DashboardQuery,
): DashboardPayload {
  const pool = filterUniverse(rows, query.index);
  return {
    window: query.window,
    index: query.index,
    rows: pool.map(toWireSecurity),
    sectors: aggregateSectors(pool, query.window).map(toSectorAggregate),
    breadth: computeBreadth(pool, query.window),
  };
}
